import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';

@Component({
  standalone: false,
  selector: 'app-session-end',
  templateUrl: './session-end.component.html',
  styleUrls: ['./session-end.component.scss']
})
export class SessionEndComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<SessionEndComponent>, private l: LoadingAkanaService) { }

  ngOnInit() {
  }

  closeModal = (v) => {
    this.dialogRef.close(v);
  }
}
